import React from 'react';
import { makeStyles } from '@mui/styles';
import Card from '../molecules/Card';
import romy from '../../assets/romy.jpg';

const useStyles = makeStyles((theme) => ({
  text: {
    textAlign: 'justify',
    width: '100%',
    whiteSpace: 'break-spaces',
  },
  container: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-around',
    padding: '0.5em',
  },
  divContainer: {
    width: '50%',
  },
  [theme.breakpoints.down(760)]: {
    text: {
      width: '85%',
    },
  },
}));

const About = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.divContainer}>
        <Card
          cat={{
            title: 'Romy',
            image: romy,
            description:
              // eslint-disable-next-line max-len
              'La reine de ce domaine ! Elle sait ouvrir les portes et ramène ses jouets quand on lui lance !',
          }}
        />
      </div>
      <div className={classes.divContainer}>
        <p className={classes.text}>
          Corinne Ritzenthaler amoureuse des chats et particulièrement du Sibérien. Mes Sibériens
          font partis intégrante de notre famille ,ils vivent et dorment avec nous dans notre maison
          ...rectification dans leur maison. Ma première Sibérienne Romy est arrivée en 2020 et au
          jour d&apos;aujourd&apos;hui j&apos;ai cinq femelles et deux mâles .Depuis l&apos;enfance
          j&apos;ai toujours souhaitée travailler avec les chats, après le premier confinement cela
          c&apos;est imposée à moi que je devais me lancer dans cette aventure qui durera je
          l&apos;espère très longtemps. J&apos;ai donc fait des recherches et rencontrée les
          propriétaires de la Chatterie Les Ailes D&apos;Eros qui ont acceptés de me vendre mes
          premiers Sibériens. J&apos;ai donc passé mon ACACED et pris pour affixe (nom) le Domaine
          de Romy.
        </p>

        <p className={classes.text}>Caractéristique du Sibérien : </p>

        <p className={classes.text}>
          Le Sibérien est originaire de Russie de grande taille à poil mi long et hypoallergénique.
          Il a une espérance de vie de 15 a 20 ans. Il est câlin et très attaché a son maitre, il
          est sociable et joueur. Un brossage régulier est nécessaire, dû a son poil mi-long. Un
          chat qui vous donnera beaucoup d’amour et de ronronthérapie .
        </p>
      </div>
    </div>
  );
};

export default About;
